/* eslint-disable */


/**
 * Create styles for `<Form />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Form />` styles
 */
const formStyles = ({ theme }) => ({});

export default formStyles;
